import { Directive, OnDestroy } from "@angular/core";
import { AbstractControl, FormGroup, ValidationErrors } from "@angular/forms";
import { Subscription } from "rxjs";
import { BaseFormFieldComponent } from "./base-form-field.component";

@Directive()
export abstract class BaseFormObjectComponent<T> extends BaseFormFieldComponent<T> implements OnDestroy {
  protected abstract form: FormGroup;
  protected onChangeSubs: Subscription[] = [];

  protected constructor() {
    super();
  }

  public ngOnInit() {
    super.ngOnInit();

    if (this.readOnly || this.disabled) {
      this.form.disable();
    }

    this.form.markAsUntouched();
  }

  public ngOnDestroy() {
    for (const sub of this.onChangeSubs) {
      sub.unsubscribe();
    }
  }

  public registerOnChange(onChange: any) {
    const subForForm = this.form.valueChanges.subscribe(onChange);
    const subForDisplayValue = this.form.valueChanges.subscribe((event) => this.onInputChange(event));

    this.onChangeSubs.push(subForForm);
    this.onChangeSubs.push(subForDisplayValue);

    super.registerOnChange(onChange);
  }

  public setDisabledState(disabled: boolean): void {
    if (disabled || this.readOnly) {
      this.form.disable();
    } else {
      this.form.enable();
    }
    super.setDisabledState(disabled);
  }

  public async onInputChange(event: T): Promise<void> {
    this.readOnlyValue = await this.toDisplayValue(event);
  }

  public async writeValue(value: T): Promise<void> {
    if (value) {
      this.form.reset({ ...value });
    }
  }

  public abstract validate(control: AbstractControl): object | null;

  protected getAllFormErrors() {
    const allErrors = {};
    Object.keys(this.form.controls).forEach((key) => {
      const controlErrors: ValidationErrors | null = this.form.controls[key].errors;

      if (controlErrors != null) {
        allErrors[key] = controlErrors;
      }
    });

    return allErrors;
  }
}
